import styled from "styled-components"

import {Card} from "../../Layout"

export const ErrorCard = styled(Card)`
  background-color: rgba(208, 2, 27, 0.5);
  padding: 12px;
  margin: 20px 0;
  color: white;
  box-shadow: 0 0 0 1px red;
`
